import React, {useState} from 'react'
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import Button from '../../../../components/Common/Button';
import {PartialCompanyMacroAreaI} from '../../../../db/models/company/macroArea';
import {MissingType} from '../../../../db/models/extra';
import {openAlert} from '../../../../slices/alert';
import {closeDialog} from '../../../../slices/dialog';
import {addCompanyMacroarea} from '../../../../api/company/macroArea';
import TextEditor from "../../../../common/components/TextEditor/main";

export const AddCompanyMacroarea = () => {
    const {register, handleSubmit, errors} = useForm<MissingType>();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [description, setDescription] = useState("");

    const onSave = (form: MissingType) => {
        const macroarea: PartialCompanyMacroAreaI = {
            name: form.name,
            description,
        };

        addCompanyMacroarea(macroarea)
            .then(() => {
                dispatch(closeDialog());
            })
            .catch((error) => {
                console.error(error);
                dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
            });
    };

    return (
        <div className="addCompanyMacroarea">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("company_addMacro_name_label")}</div>
                    <input
                        type="text"
                        placeholder={t("company_addMacro_name_ph")}
                        name="name"
                        ref={register({required: true})}
                    />
                    {errors.name && <span className="error">{t("company_addMacro_name_error")}</span>}
                </div>
                <div className="element">
                    <div className="label">{t("company_addMacro_desc_label")}</div>
                    <TextEditor
                        editorStyle={{minHeight: "150px"}}
                        placeholder={t("company_addMacro_desc_ph")}
                        defaultValue={description}
                        HTMLvalueOnChangeCB={setDescription}/>
                </div>
                <Button type="submit">{t("company_addMacro_submit")}</Button>
            </form>
        </div>
    );
};
